import { makeStyles } from '../../../styles';
const useStyles = makeStyles((theme) => ({
    marginTop: {
        marginTop: theme.spacing(3),
    },
    analyticsBanner: {
        transition: 'margin-top 0.5s',
        '& .MuiPaper-root': {
            marginBottom: 0,
        },
    },
    header: {
        color: theme.colors.text[900],
    },
    body: {
        color: theme.colors.gray[700],
    },
    content: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2),
        padding: '0px',
    },
    image: {
        width: 114,
    },
}));
export default useStyles;
//# sourceMappingURL=AnalyticsBanner.styles.js.map